import { createEntityAdapter, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../staticData/staticData";
import * as Sentry from "@sentry/react";
const vehicleAdapter=createEntityAdapter();
const initialState=vehicleAdapter.getInitialState({});
const serverURL=server
export const getAllVehicle=createAsyncThunk('vehicle/getallvehicle', async ({driverId, site})=>{
     const config={
        headers: {'driverId': `${driverId}`}
    }
    try {
        const response=await axios.get(serverURL+"drivertempcheck/vehicle?site="+site,config);
        return response.data;
    } catch (error) {
        Sentry.captureException(error)
        Sentry.captureMessage("Error getAllVehicle, driverId: "+driverId+", site: "+site);
    }
})

const vehicleSlice=createSlice({
    name:'vehicle',
    initialState,
    reducers:{},
    extraReducers: builder=>{
        builder.addCase(getAllVehicle.fulfilled,(state, action)=>{
            state.status="success"
            state.entities.vehicleList=action.payload.sort((a,b)=>a.license.localeCompare(b.license));
        })
        .addCase(getAllVehicle.pending, (state,action)=>{
            state.status="pending"
        })
        .addCase(getAllVehicle.rejected, (state,action)=>{
            state.status="idle"
        })
    }
})
export default vehicleSlice.reducer;